import { render } from "./Sobre.vue?vue&type=template&id=9eb8666a&scoped=true"
import script from "./Sobre.vue?vue&type=script&lang=js"
export * from "./Sobre.vue?vue&type=script&lang=js"

import "./Sobre.vue?vue&type=style&index=0&id=9eb8666a&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\vue-argon-centrion\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9eb8666a"]])

export default __exports__